import * as React from 'react';
import { Field } from 'redux-form';
import { Col, FormGroup, Row } from 'react-bootstrap';
import { isRequired } from '../../../../../../util/validators';
import { II18nMessages } from '../../../../../../services/branding/models';
import FieldFormControl from '../../../../../../components/FieldFormControl';
import { IChannel } from '../../../../../../data/api/models';
import FaCheck from 'react-icons/fa/check';

interface ITripDetailsForm {
  i18n: II18nMessages;
  channel: IChannel;
}

class CruiseQuestion extends React.Component<ITripDetailsForm> {
  public renderQuestions = () => {
    const { channel } = this.props;
    return (
        <Row className="trip-type-container">
          <Col sm={6} className="trip-type-btn-container" style={{ marginBottom: '5px' }}>
            <Field
              id="cruise-cover-yes"
              name="going_on_cruise"
              type="radio"
              value={true}
              component={FieldFormControl}
              complexValue={true}
              className="answer"
              validate={[isRequired]}
            >
              <div className={'trip-type-btn'}>
                Yes
                <FaCheck />
              </div>
            </Field>
          </Col>
          <Col sm={6} className="trip-type-btn-container" style={{ marginBottom: '5px' }}>
            <Field
              id="cruise-cover-no"
              name="going_on_cruise"
              type="radio"
              value={false}
              component={FieldFormControl}
              complexValue={true}
              className="answer"
              validate={[isRequired]}
            >
              <div className={'trip-type-btn'}>
                No
                <FaCheck />
              </div>
            </Field>
          </Col>
          <div className="trip-type-btn-container" style={{marginTop: '30px'}}>
            {channel.key === 'fst-b2c' && (
              <p style={{ fontSize: '14px' }}>
                Let us know if you are planning on going on an ocean or river cruise (including UK cruises) so that we
                can show you options to cover additional benefits such as cabin confinement and missed departure.
                You don’t need to tell us about ferry crossings.
              </p>
            )}
          </div>
        </Row>
    );
  }

  public render() {
    const { i18n } = this.props;
    return (
      <div className="section">
      <FormGroup controlId="cruise-cover">
        <Row>
          <Col sm={3}>
            {i18n.quote.tripDetails.cruise}
          </Col>
          <Col sm={9}>
            {this.renderQuestions()}
          </Col>
        </Row>
      </FormGroup>
      </div>
    );
  }
}

export default CruiseQuestion;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/TripDetails/components/CruiseQuestion/CruiseQuestion.tsx